/* eslint-disable */

import $ from 'jquery'
import 'slick-carousel'

import Vue  from 'vue'
import Vuex from 'vuex'

import UserWidget                       from './components/UserWidget.vue'
import UserProfileForm                  from './components/UserProfileForm.vue'
import InstantWinBasic                  from './components/InstantWinBasic.vue'
import InstantWinAnimation              from './components/InstantWinAnimation.vue'
import InstantWinBasicAttempts
                                        from './components/InstantWinBasicAttempts'
import InstantWinTeaser                 from './components/InstantWinTeaser.vue'
import InstantWinRewardForm
                                        from './components/InstantWinRewardForm.vue'
import InstantWinPartyCollection
                                        from './components/InstantWinPartyCollection.vue'
import InstantWinPartyCollectionGeneric
                                        from './components/InstantWinPartyCollectionGeneric.vue'
import InstantWinArchive
                                        from './components/InstantWinArchive.vue'
import ShareButtons                     from './components/ShareButtons.vue'
// import InstantWinPartyDellaDomenica from
// './components/InstantWinPartyDellaDomenica.vue'
import RewardsCatalog                   from './components/RewardsCatalog.vue'
import RewardsDetail                    from './components/RewardsDetail.vue';
import BasicModal                       from './components/BasicModal.vue';
import RewardsSliderCurrentTier         from './components/RewardsSliderCurrentTier.vue';
import RewardsSliderSpecial             from './components/RewardsSliderSpecial.vue';
import GiocaEVinci                      from './components/GiocaEVinci.vue';
import InstantWinSlider                 from './components/InstantWinSlider.vue';
import RewardsListRetrieved             from './components/RewardsListRetrieved.vue';
import BadgeCounter                     from './components/BadgeCounter.vue';
import ClusterWidget                    from './components/ClusterWidget.vue';

import NewsletterBox       from './components/NewsletterBox.vue';
import BannersCarousel     from './components/BannersCarousel.vue';
import BandPartyCollection from './components/BandPartyCollection.vue';
import BandPartyMoments    from "./components/BandPartyMoments";
import BandContest         from './components/BandContest.vue';
import BandRewardsTiers    from './components/BandRewardsTiers.vue';
import BandGeneric         from "@/components/BandGeneric";

import ButtonBadgesModal        from './components/ButtonBadgesModal.vue';
import PortaUnAmico             from './components/PortaUnAmico';
import CarouselBasic            from './components/CarouselBasic.vue';
import CardsStepsSlider         from './components/CardsStepsSlider.vue';
import CardsSpecifications      from './components/CardsSpecifications.vue';
import CardsImageSlider         from './components/CardsImageSlider.vue';
import ShopCouponsBand          from "./components/ShopCouponsBand";
import ShopCouponsListRetrieved from "./components/ShopCouponsListRetrieved";
import MessageBar               from "./components/MessageBar";
import HeaderVantaggi           from "@/components/HeaderVantaggi";

import UserCluster       from "./components/UserCluster";
import AspiraFissoMobile from "./components/AspiraFissoMobile";

import timparty_store from './store.js';
import markup         from "./v-markup.js";

Vue.use(Vuex);

Vue.config.productionTip = false;
if (process.env.NODE_ENV === 'production') {
  Vue.config.devtools = false;
}
else {
  Vue.config.devtools = true;
  Vue.config.silent   = true;
  Vue.config.debug    = false;
}


// TODO: multiple instances or single one?
let elements = document.getElementsByClassName('vue-container')
let store    = new Vuex.Store(timparty_store);
for (let el of elements) {
  new Vue({
    el: el,
    components: {
      UserWidget,
      UserProfileForm,
      BasicModal,
      InstantWinBasic,
      InstantWinAnimation,
      InstantWinBasicAttempts,
      InstantWinTeaser,
      InstantWinPartyCollection,
      InstantWinPartyCollectionGeneric,
      InstantWinArchive,
      //InstantWinPartyDellaDomenica,
      InstantWinRewardForm,
      RewardsCatalog,
      RewardsDetail,
      RewardsSliderCurrentTier,
      RewardsSliderSpecial,
      GiocaEVinci,
      InstantWinSlider,
      RewardsListRetrieved,
      BadgeCounter,
      ClusterWidget,
      NewsletterBox,
      BannersCarousel,
      BandPartyCollection,
      BandPartyMoments,
      BandGeneric,
      BandContest,
      BandRewardsTiers,
      ButtonBadgesModal,
      ShopCouponsBand,
      ShopCouponsListRetrieved,
      PortaUnAmico,
      ShareButtons,

      CarouselBasic,

      CardsStepsSlider,
      CardsSpecifications,
      CardsImageSlider,

      UserCluster,
      MessageBar,
      AspiraFissoMobile,
      HeaderVantaggi,
    },
    store: store
  })
}
Vue.directive('markup', markup);


// console.log('Ver. 202403201446SNL');

$(document).ready(function () {
  // slick carousel

  $('.slick-carousel').slick();

  $('.slick-carousel-prev').click(function () {
    $(this).closest('.paragraph-carousel-container').find('.slick-carousel').slick('slickPrev');
  });

  $('.slick-carousel-next').click(function () {
    $(this).closest('.paragraph-carousel-container').find('.slick-carousel').slick('slickNext');
  });


  // basic toggler

  $(document).on('click', '.timparty-toggler', function (e) {
    console.log('toggle mobile menu');
    var target    = $(e.target).data('target');
    var css_class = $(e.target).data('class');
    console.log('Toggling target ' + target + ' with class ' + css_class);
    if (target) {
      if (!css_class) {
        css_class = "d-none"
      }
      $(target).toggleClass(css_class);
    }


  });
});


/*
new Vue({
	el: '#page',
	components: { UserWidget, InstantWinBasic, InstantWinRewardForm, RewardsCatalog, RewardsDetail },
	store: new Vuex.Store(timparty_store),
})
*/
